import { createVuetify } from 'vuetify'
// eslint-disable-next-line sonarjs/no-wildcard-import -- intentional: registers all Vuetify components globally
import * as components from 'vuetify/components'

export default defineNuxtPlugin(nuxtApp => {
	const vuetify = createVuetify({
		components,
		ssr: true,
		theme: {
			defaultTheme: 'light',
		},
	})

	nuxtApp.vueApp.use(vuetify)
})
